import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Brain, BatteryWarning } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-10 px-4 md:px-8 relative" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-135">
            El insomnio moderno no es un problema de voluntad.
          </h2>
          <p className="text-xl text-[#b8c4d6] font-sans" data-id="element-136">
            Estamos viviendo en un entorno diseñado para mantenernos despiertos.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-137">
          {[{
          icon: <Zap className="w-8 h-8 text-cyan-400" data-id="element-138" />,
          title: 'Luces LED',
          desc: 'Imitan el sol del mediodía, engañando a tu cerebro a las 10 PM.'
        }, {
          icon: <BatteryWarning className="w-8 h-8 text-cyan-400" data-id="element-139" />,
          title: 'Cafeína Oculta',
          desc: 'Bloquea tus receptores de fatiga mucho después de tu última taza.'
        }, {
          icon: <Brain className="w-8 h-8 text-cyan-400" data-id="element-140" />,
          title: 'Estrés Crónico',
          desc: 'Mantiene tus niveles de cortisol disparados cuando deberían estar en cero.'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} viewport={{
          once: true
        }} className="bg-[#0f1628]/50 border border-cyan-500/10 p-6 rounded-xl text-center" data-id="element-141">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-cyan-500/10 mb-4" data-id="element-142">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-143">
                {item.title}
              </h3>
              <p className="text-[#b8c4d6] text-sm" data-id="element-144">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} viewport={{
        once: true
      }} className="bg-[#0f1628]/30 border border-cyan-500/10 p-8 rounded-2xl text-center" data-id="element-145">
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-146">
            Dormir mal no es solo estar cansado. Es operar{' '}
            <strong className="text-white" data-id="element-147">"borracho" de fatiga</strong>, con
            una neblina mental que arruina tu productividad, sabotea tu
            metabolismo y te envejece prematuramente.
          </p>
        </motion.div>
      </div>
    </section>;
}